import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FormControlLabel, Checkbox, IconButton } from '@mui/material';
import { Autocomplete } from '@totalsoft/rocket-ui';
import { Delete, Edit, Close, Check } from '@mui/icons-material';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import { StyledTableBodyCell, StyledTableRow } from 'components/common/Styles';
import { emptyString } from 'utils/constants';
import { ADMIN_PROPERTIES_WRITE } from 'constants/rightsCodes';
import { usePermission } from 'providers/RightsHooks';

const PropertyUserGroupItemComponent = ({
  propertyUserGroup,
  onPropertyChanged,
  index,
  userGroups,
  validation,
  onDelete,
  onCancel,
  onEdit
}) => {
  const { t } = useTranslation();
  const canWrite = usePermission(ADMIN_PROPERTIES_WRITE);

  const userGroup = userGroups.find(x => x.id === propertyUserGroup.userGroupId);

  return (
    <StyledTableRow>
      {propertyUserGroup.inEdit ? (
        <>
          <StyledTableBodyCell sx={{ w: 1 / 2 }}>
            <Autocomplete
              fullWidth
              isClearable={false}
              label={t('Property.UserGroup')}
              value={propertyUserGroup.editValue.userGroupId}
              simpleValue
              options={userGroups}
              onChange={event => onPropertyChanged('userGroupId', event, index)}
              error={!isValid(validation[index].editValue.userGroupId)}
              helperText={getErrors(validation[index].editValue.userGroupId)}
              isSearchable={true}
              required
            />
          </StyledTableBodyCell>
          <StyledTableBodyCell>
            <FormControlLabel
              control={
                <Checkbox
                  checked={propertyUserGroup.editValue.allowRead}
                  color='primary'
                  onChange={event => onPropertyChanged('allowRead', event.target.checked, index)}
                />
              }
            />
          </StyledTableBodyCell>
          <StyledTableBodyCell>
            <FormControlLabel
              control={
                <Checkbox
                  checked={propertyUserGroup.editValue.allowWrite}
                  color='primary'
                  onChange={event => onPropertyChanged('allowWrite', event.target.checked, index)}
                />
              }
            />
          </StyledTableBodyCell>
        </>
      ) : (
        <>
          <StyledTableBodyCell sx={{ w: 1 / 2 }}>{userGroup?.name || emptyString}</StyledTableBodyCell>
          <StyledTableBodyCell>{propertyUserGroup.allowRead === true ? <Check color='success' /> : <Close />}</StyledTableBodyCell>
          <StyledTableBodyCell>{propertyUserGroup.allowWrite === true ? <Check color='success' /> : <Close />}</StyledTableBodyCell>
        </>
      )}
      <StyledTableBodyCell align='right'>
        {propertyUserGroup.inEdit ? (
          <IconButton
            size='small'
            color='primary'
            title={t('Tooltips.Cancel')}
            onClick={() => {
              onCancel(index);
            }}
          >
            <Close fontSize='small' />
          </IconButton>
        ) : (
          <IconButton size='small' color='primary' title={t('Tooltips.Edit')} onClick={() => onEdit(index)} disabled={!canWrite}>
            <Edit fontSize='small' />
          </IconButton>
        )}
        <IconButton
          size='small'
          color='primary'
          title={t('Tooltips.Delete')}
          onClick={() => onDelete(index)}
          disabled={!canWrite || !propertyUserGroup.userGroupId}
        >
          <Delete />
        </IconButton>
      </StyledTableBodyCell>
    </StyledTableRow>
  );
};

PropertyUserGroupItemComponent.propTypes = {
  propertyUserGroup: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  onPropertyChanged: PropTypes.func.isRequired,
  userGroups: PropTypes.array.isRequired,
  validation: PropTypes.object,
  onDelete: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  onEdit: PropTypes.func
};

export default PropertyUserGroupItemComponent;
